var React = require('react');

function GatsbyLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.81 0C36.814 0 0 36.814 0 81.81c0 44.995 36.814 81.81 81.81 81.81 44.995 0 81.81-36.815 81.81-81.81C163.62 36.814 126.805 0 81.81 0zM36.23 127.39c-12.271-12.272-18.7-28.634-18.7-44.411l63.695 63.11c-16.361-.584-32.723-6.428-44.995-18.699zm59.604 16.946l-76.55-76.55C25.712 39.151 51.424 17.53 81.81 17.53c21.621 0 40.32 10.518 52.008 26.296l-8.766 7.596c-9.934-13.44-25.711-22.205-43.242-22.205-22.79 0-42.074 14.609-49.67 35.061l67.2 67.201c16.947-5.843 29.803-20.452 33.893-37.983h-28.049V81.81h40.905c0 30.386-21.621 56.098-50.255 62.526z"}));
}

GatsbyLogo.defaultProps = {"viewBox":"0 0 164 164"};

module.exports = GatsbyLogo;

GatsbyLogo.default = GatsbyLogo;
